import React, { useState, useEffect, useRef } from "react";
import { API_URL, getValFromLS } from "../helpers";
import Alert from "../components/Alert";
import InputFile from "../components/InputFile";
import Input from "../components/Input";
import Checkbox from "../components/Checkbox";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const Uploaded = ({ src, name, remove }) => {
  return (
    <div className="uploaded">
      <div>
        <button type="button" onClick={(e) => remove(name)}>
          <i className="fa fa-times fa-lg" />
        </button>
      </div>
      <img src={src} alt={name} />
    </div>
  );
};

const Uploading = () => {
  return (
    <label className="uploading">
      <i className="fa fa-circle-o-notch fa-spin fa-3x" />
    </label>
  );
};

const Upload = ({ name, update }) => {
  return (
    <label htmlFor={name} className="upload">
      <i className="fa fa-image fa-3x" />
    </label>
  );
};

const Form2 = ({ update }) => {
  const [names, setNames] = useState({
    img1: {
      status: 0,
      url: "",
    },
  });
  const [errors, setErrors] = useState([]);
  const [photo, setPhoto] = useState(null);
  const [msg, setMsg] = useState({});
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });

  const formElement = useRef(null);

  useEffect(() => {
    init();

    // eslint-disable-next-line
  }, []);

  /*
  useEffect(() => {
    if (photo) {
      handleUpload();
    }
  }, [photo]);
  */

  const init = async () => {
    const token = getValFromLS("friendsDash", true)
      ? getValFromLS("friendsDash", true)
      : "";

    const url = new URL(`${API_URL}/auth/friendsDashForm2Init`);
    const params = {
      token,
    };
    url.search = new URLSearchParams(params);

    try {
      const response = await fetch(url, {
        method: "GET",
        cache: "no-store",
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        if (json.img1) {
          handleUpdate("img1", { status: 1, url: json.img1 });
        }
        if (json.youtubeId) {
          setNames((names) => ({
            ...names,
            youtubeId: json.youtubeId,
            title: json.title,
          }));
        }
        setAlert({});
      } else {
        setAlert({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setAlert({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  const handleUpdate = (name, value) => {
    if (name === "photo") {
      if (value.size > 5000000) {
        setMsg({
          type: "error",
          text: "Please limit photo upload size to 5 MB.",
        });
        return false;
      } else {
        setNames((names) => ({ ...names, img: name }));
        setPhoto(value);
      }
    } else {
      setNames((names) => ({ ...names, [name]: value ? value : "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMsg({
      type: "working",
      text: "",
    });

    if (photo) {
      handleUpdate(`img1`, { status: 2, url: "" });
    }

    const url = new URL(`${API_URL}/auth/friendsDashForm2`);
    let formData = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      if (key === "remove") {
        formData.append(key, value ? "1" : "0");
      } else if (key === "img1" || key === "photo") {
      } else {
        formData.append(key, value);
      }
    });
    formData.append("photo", photo ? photo : "");
    formData.append("token", getValFromLS("friendsDash", true));

    try {
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        if (json.photoUrl) {
          handleUpdate(`img1`, { status: 1, url: json.photoUrl });
        }
        setMsg({});
      } else {
        setErrors(json.fields);
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  const handleRemove = async (img) => {
    setMsg({});
    handleUpdate(`img1`, { status: 2, url: "" });

    const url = new URL(`${API_URL}/auth/friendsDashForm2Remove`);
    let data = new FormData();
    data.append("img", img);
    data.append("token", getValFromLS("friendsDash", true));

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        if (json.photoUrl === "") {
          handleUpdate("img1", { status: 0, url: "" });
        }
        setAlert({});
      } else {
        handleUpdate(`img1`, { status: 0, url: "" });
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      handleUpdate(`img1`, { status: 0, url: "" });
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <>
      {alert.type ? (
        <Alert data={alert} />
      ) : (
        <>
          <form
            ref={formElement}
            method="post"
            action="/"
            onSubmit={(e) => handleSubmit(e)}
            className="well"
          >
            <h3 style={{ marginTop: "0" }}>Upload Photo / Add YouTube Video</h3>

            <p>
              Use this page below to enhance your friendraising donation page
              with a photo and video. If you would like to embed a public
              YouTube video on your donation form, please enter its ID below.
            </p>

            <div className="form-group">
              <InputFile
                name="photo"
                label="Select Photo File (JPEG or PNG format)"
                reqd={false}
                value={""}
                update={handleUpdate}
                errors={errors}
              />
              <div className="empty" />
            </div>

            <div className="form-group">
              <Input
                name="youtubeId"
                label="YouTube Video Id (ex. 04s-2awcV0o)"
                reqd={false}
                value={names.youtubeId || ""}
                update={handleUpdate}
                errors={errors}
              />
              <Input
                name="title"
                label="Optional Video Title"
                reqd={false}
                value={names.title || ""}
                update={handleUpdate}
                errors={errors}
              />
            </div>

            <div className="form-group checkbox" style={{ marginTop: "10px" }}>
              <Checkbox
                name="remove"
                label="Check if you would like to remove your existing video."
                checked={names.remove || false}
                click={handleUpdate}
              />
            </div>

            <div className="msg-submit">
              {msg.type && <Msg data={msg} />}

              <div
                className={
                  msg.type === "working" || msg.type === "success"
                    ? "hidden"
                    : "submit-container"
                }
              >
                <Submit path="" left="" submit="Submit Updates" />
              </div>
            </div>
          </form>

          <div
            className="img-grid"
            style={{ marginTop: "15px", marginBottom: "20px" }}
          >
            <div>
              {names.img1.status === 1 ? (
                <Uploaded src={names.img1.url} name="1" remove={handleRemove} />
              ) : names.img1.status === 2 ? (
                <Uploading />
              ) : (
                <Upload name="1" update={handleUpdate} />
              )}
            </div>

            {names.youtubeId ? (
              <div className="yt-container">
                <iframe
                  width="534"
                  height="300"
                  src={`//www.youtube.com/embed/${names.youtubeId}?rel=0`}
                  frameBorder="0"
                  allowFullScreen=""
                  title="Video"
                ></iframe>
              </div>
            ) : (
              <div className="placeholder-container">
                <i className="fa fa-file-video-o fa-3x" />
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Form2;
